export default __webpack_public_path__ + "static/media/one.db986bbb.mp4";